import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import styles from "./css/index.css";
const Overlay = _ref => {
  let {
    as: ComponentToRender,
    children,
    color,
    className,
    fixedToRelative,
    enabled,
    visible,
    animation,
    ...props
  } = _ref;
  const positionClass = fixedToRelative ? styles['fixed-to-relative'] : styles['fixed-to-page'];
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: cx(styles.overlay, styles[`color-${color}`], positionClass, className, {
      [styles['not-enabled']]: !enabled,
      [styles['not-visible']]: !visible,
      [styles.animated]: animation
    })
  }, props), children);
};
process.env.NODE_ENV !== "production" ? Overlay.propTypes = {
  as: PropTypes.elementType,
  /**
   * Element/content to render in the Overlay
   */
  children: PropTypes.node,
  /**
   * The color theme of the overlay
   */
  color: PropTypes.oneOf(['light', 'dark']),
  /**
   * Additional classes to be used
   */
  className: PropTypes.string,
  /**
   * Whether or not to position the overlay within a relative
   */
  fixedToRelative: PropTypes.bool,
  /**
   * Whether or not the overlay is enabled. This is useful when the overlay is animated and must be always mounted.
   *
   * When false, it disabled the ability to click on anything in the overlay and visually hides the overlay
   */
  enabled: PropTypes.bool,
  /**
   * Whether or not the overlay is visible. This is useful when the overlay is animated and must be always mounted
   *
   * Unlike `enabled`, this prop only influences whether the overlay is visible, but still allows the contents
   * of the overlay to be interactive
   */
  visible: PropTypes.bool,
  /**
   * Allow animated styles on the Overlay
   */
  animation: PropTypes.bool
} : void 0;
Overlay.defaultProps = {
  as: 'aside',
  color: 'dark',
  className: '',
  fixedToRelative: false,
  enabled: true,
  visible: true,
  animation: true
};
export default Overlay;